module.exports = __webpack_public_path__ + "img/Kielland_Gift3.b7373c2f.jpg";